(function() {
    angular
        .module("app")
        .factory("usersService", usersService)

    usersService.$inject = ["$rootScope", "$http", "queryStringService"]

    function usersService($rootScope, $http, queryStringService) {
        var service = {}

        /**
            Get all users
            @returns {*}
         **/
        service.getUsers = function(customerID) {
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/users"
                    + "?perpage=" + 1000
                    + "&customer_id=" + customerID
            }).then(getUsersComplete, getUsersFailed)

            function getUsersComplete(response) {
                return response.data
            }

            function getUsersFailed(error) {
                console.error(error)
            }
        }

        /**
            Get single user
            @param {int} userID
            @returns {*}
         **/
        service.getUser = function(userID) {
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/users/" + userID
            }).then(getUserComplete, getUserFailed)

            function getUserComplete(response) {
                return response.data
            }

            function getUserFailed(error) {
                console.error(error)
            }
        }

        /**
            Refresh current session — returns the same shape as the login response
            (as_session_json), including fresh scoped_permissions and
            permissions_state_hash.
            @returns {Promise}
         **/
        service.getSessionRefresh = function() {
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/sessions/me"
            }).then(function(response) { return response.data })
        }

        /**
            Create new user
            @param formData
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.createUser = function(formData, successCallback, failureCallback) {
            var queryJson = queryStringService.createQueryJson(formData, "user")

            return $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/users/",
                data: queryJson
            }).then(createUserComplete, createUserFailed)

            function createUserComplete(response) {
                successCallback()
                return response.data
            }

            function createUserFailed(error) {
                console.error(error)
                failureCallback(error.data)
            }
        }

        /**
            Edit existing user
            @param {int} userID
            @param formData
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.editUser = function(userID, formData, successCallback, failureCallback) {
            var queryJson = queryStringService.createQueryJson(formData, "user")

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/users/" + userID,
                data: queryJson
            }).then(editUserComplete, editUserFailed)

            function editUserComplete(response) {
                successCallback()
                return response.data
            }

            function editUserFailed(error) {
                console.error(error)
                failureCallback(error)
            }
        }

        /**
            Delete existing user
            @param {int} userID
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.deleteUser = function(userID, successCallback, failureCallback) {
            return $http({
                method: "DELETE",
                url: $rootScope.config.apiUrl + "/users/" + userID
            }).then(deleteUserComplete, deleteUserFailed)

            function deleteUserComplete(response) {
                successCallback()
                return response.data
            }

            function deleteUserFailed(error) {
                failureCallback(error)
                console.error(error)
            }
        }

        /**
            Request password reset
            @param userEmail
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.requestPasswordReset = function(userEmail, successCallback, failureCallback) {
            return $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/users/password" + "?" + "user[email]=" + encodeURIComponent(userEmail),
                headers: {"Accept": "application/json"}
            }).then(requestPasswordResetComplete, requestPasswordResetFailed)

            function requestPasswordResetComplete(response) {
                successCallback()
                return response.data
            }

            function requestPasswordResetFailed(error) {
                failureCallback(error)
                console.error(error)
            }
        }

        /**
            Reset password
            @param resetPasswordFormData
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.resetPassword = function(resetPasswordFormData, successCallback, failureCallback) {
            var queryJson = queryStringService.createQueryJson(resetPasswordFormData, "user")

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/users/password",
                headers: {"Accept": "application/json"},
                data: queryJson
            }).then(resetPasswordComplete, resetPasswordFailed)

            function resetPasswordComplete(response) {
                successCallback()
                return response.data
            }

            function resetPasswordFailed(error) {
                console.error(error)
                failureCallback(error)
            }
        }

        /**
            Confirm user
            @param userConfirmationFormData
            @param {int} confirmationToken
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.confirmUser = function(userConfirmationFormData, confirmationToken, successCallback, failureCallback) {
            var queryString = queryStringService.createQueryString(userConfirmationFormData, "user")
            return $http({
                method: "PATCH",
                url: $rootScope.config.apiUrl + "/users/confirmation" + "?" + queryString,
                headers: {"Accept": "application/json"},
                data: {
                    confirmation_token: confirmationToken
                }
            }).then(confirmUserComplete, confirmUserFailed)

            function confirmUserComplete(response) {
                successCallback()
                return response.data
            }

            function confirmUserFailed(error) {
                console.error(error)
                failureCallback(error.data)
            }
        }

        service.searchUsers = function(searchData, page, perPage, minimumTimeMs, successCallback, failureCallback) {

            const start = new Date().getTime()

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/users/search?"
                + "search=" + searchData
                + "&page=" + page
                + "&perpage=" + perPage
            }).then(success, failure)

            function success(response) {
                setTimeout(() => {
                    if (successCallback !== undefined) {
                        successCallback(response.data, response.headers("Total"))
                    }
                }, Math.min(0, minimumTimeMs - (new Date().getTime() - start)))
            }

            function failure(error) {
                setTimeout(() => {
                    console.error(error)
                    if (failureCallback !== undefined) {
                        failureCallback(error)
                    }
                }, Math.min(0, minimumTimeMs - (new Date().getTime() - start)))
            }
        }

        return service
    }
})()
